module.exports = __webpack_public_path__ + "img/order-setup-eat-in-table.b0bee73b.svg";